module.exports = __webpack_public_path__ + "img/h_header-2.d63346c4.png";